// extracted by mini-css-extract-plugin
export default {"policyPage":"styles_policyPage__8Ae-b","title":"styles_title__mEJk-"};